[
	{
		"header": "Order Date time",
		"field": "dateRange",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Side",
		"field": "buySellCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "B-(buy)",
				"value": "B"
			},
			{
				"label": "SL-(sell long)",
				"value": "SL"
			},
			{
				"label": "SS-(short sale)",
				"value": "SS"
			},
			{
				"label": "SX-(short sale exempt)",
				"value": "SX"
			}
		]
	},
	{
		"header": "Price",
		"field": "limitPrice",
		"datatype": "Float",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Qty",
		"field": "shareQuantity",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Branch Seq No",
		"field": "branchSeqNum",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routed Order ID",
		"field": "routedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Sent TO Routed Order ID",
		"field": "sentToRoutedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Record Type",
		"field": "recordType",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Action Type Code",
		"field": "actionTypeCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "C-(correct)",
				"value": "C"
			},
			{
				"label": "D-(delete)",
				"value": "D"
			},
			{
				"label": "N-(new)",
				"value": "N"
			},
			{
				"label": "R-(replacement)",
				"value": "R"
			}
		]
	},
	{
		"header": "Firm ROE ID",
		"field": "firmRoeID",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Correction Deletion Timestamp",
		"field": "correctionDeletionTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Resubmit",
		"field": "resubmit",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "Y-(yes)",
				"value": "Y"
			}
		]
	},
	{
		"header": "Order Receiving Date",
		"field": "orderReceivingDate",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Firm Order ID",
		"field": "firmOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routing Firm Mpid",
		"field": "routingFirmMpid",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Order Received Timestamp",
		"field": "orderReceivedTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Recv Method",
		"field": "receivedMethod",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "E-(Electronic)",
				"value": "E"
			},
			{
				"label": "N-(Manual)",
				"value": "N"
			}
		]
	},
	{
		"header": "Customer Instruction Flag",
		"field": "customerInstructionFlag",
		"datatype": "char",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Stop Price",
		"field": "stopPrice",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Time In Force Code",
		"field": "timeInForceCode",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Expiration Date",
		"field": "expirationDate",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Expiration Time",
		"field": "expirationTime",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Dnr DNI",
		"field": "dnrDni",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Splhand1",
		"field": "splHand1",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "‘ADD’ (Add)",
				"value": "ADD"
			},
			{
				"label": "‘AOB’ (At or Between)",
				"value": "AOB"
			},
			{
				"label": "‘AON’ (All or None)",
				"value": "AON"
			},
			{
				"label": "‘ALO’ (Add Liquidity Only)",
				"value": "ALO"
			},
			{
				"label": "‘CND’ (Conditional Order)",
				"value": "CND"
			},
			{
				"label": "‘CNH’ (Cash Not Held)",
				"value": "CNH"
			},
			{
				"label": "‘CPR’ (Counterparty Restriction)",
				"value": "CPR"
			},
			{
				"label": "‘CSH’(Delivery Instructions: Cash- trade settles on the same trade date.)",
				"value": "CSH"
			},
			{
				"label": "‘DIR’(Directed Orders)",
				"value": "DIR"
			},
			{
				"label": "‘DLO’(Discretionary Limit Order )",
				"value": "DLO"
			},
			{
				"label": "‘E.W’(Exchange for Physical Transaction )",
				"value": "E.W"
			},
			{
				"label": "‘FBA’ NYSE Floor Broker Algorithm",
				"value": "FBA"
			},
			{
				"label": "‘F0’(Stay on Offerside)",
				"value": "F0"
			},
			{
				"label": "‘F3’(Go Along)",
				"value": "F3"
			},
			{
				"label": "‘F6’(Participate Don’t Initiate)",
				"value": "F6"
			},
			{
				"label": "‘F7’(Strict Scale)",
				"value": "F7"
			},
			{
				"label": "‘F8’(Try to Scale)",
				"value": "F8"
			},
			{
				"label": "‘F9’(Stay on Bidside)",
				"value": "F9"
			},
			{
				"label": "‘FA’(No Cross)",
				"value": "FA"
			},
			{
				"label": "‘FB’(OK to Cross)",
				"value": "FB"
			},
			{
				"label": "‘Fb’(Strict Limit)",
				"value": "Fb"
			},
			{
				"label": "‘FC’(Call First)",
				"value": "FC"
			},
			{
				"label": "‘Fc’(Ignore Price Validity Checks)",
				"value": "Fc"
			},
			{
				"label": "‘FD’(Percent of Volume)",
				"value": "FD"
			},
			{
				"label": "‘Fd’(Peg to Limit Price)",
				"value": "Fd"
			},
			{
				"label": "‘Fe’(Work to Target Strategy)",
				"value": "Fe"
			},
			{
				"label": "‘FH’(Reinstate on System Failure)",
				"value": "FH"
			},
			{
				"label": "‘FI’(Institutions Only)",
				"value": "FI"
			},
			{
				"label": "‘FJ’(Reinstate on Trading Halt)",
				"value": "FJ"
			},
			{
				"label": "‘FK’(Cancel on Trading Halt)",
				"value": "FK"
			},
			{
				"label": "‘FL’(Last Peg )",
				"value": "FL"
			},
			{
				"label": "‘FM’(Mid)",
				"value": "FM"
			},
			{
				"label": "‘FN’(Non)",
				"value": "FN"
			},
			{
				"label": "‘FO’(Opening Peg)",
				"value": "FO"
			},
			{
				"label": "‘FOK’(Fill or Kill)",
				"value": "FOK"
			},
			{
				"label": "‘FP’(Market Peg)",
				"value": "FP"
			},
			{
				"label": "‘FQ’(Cancel on System Failure)",
				"value": "FQ"
			},
			{
				"label": "‘FR’(Primary Peg)",
				"value": "FR"
			},
			{
				"label": "‘FS’(Suspend)",
				"value": "FS"
			},
			{
				"label": "‘FT’(Fixed Peg to Local Best Bid or Offer at time of order)",
				"value": "FT"
			},
			{
				"label": "‘FW’(Peg to VWAP)",
				"value": "FW"
			},
			{
				"label": "‘FX’(Trade Along)",
				"value": "FX"
			},
			{
				"label": "‘FY’(Try to Stop)",
				"value": "FY"
			},
			{
				"label": "‘FZ’(Cancel if Not Best)",
				"value": "FZ"
			},
			{
				"label": "‘G’(G Order)",
				"value": "G"
			},
			{
				"label": "‘IDX’(Intra-Day Cross)",
				"value": "IDX"
			},
			{
				"label": "‘IO’(Imbalance Only)",
				"value": "IO"
			},
			{
				"label": "‘IOC’(Immediate or Cancel)",
				"value": "IOC"
			},
			{
				"label": "‘ISO’(Intermarket Sweep Order)",
				"value": "ISO"
			},
			{
				"label": "‘LOC’(Limit on Close)",
				"value": "LOC"
			},
			{
				"label": "‘LOO’(Limit on Open )",
				"value": "LOO"
			},
			{
				"label": "‘MAC’(Market at Close)",
				"value": "MAC"
			},
			{
				"label": "‘MAO’(Market at Open)",
				"value": "MAO"
			},
			{
				"label": "‘MOB’ (Mid-point or Better)",
				"value": "MOB"
			},
			{
				"label": "‘MOC’(Market on Close)",
				"value": "MOC"
			},
			{
				"label": "‘MOO’(Market on Open)",
				"value": "MOO"
			},
			{
				"label": "‘MPT’(Merger Related Transfer Position)",
				"value": "MPT"
			},
			{
				"label": "‘MQT’(Minimum Quantity)",
				"value": "MQT"
			},
			{
				"label": "‘MTL’(Market to Limit)",
				"value": "MTL"
			},
			{
				"label": "‘ND’(Delivery Instructions: Next Day - trade settles on a next trade date.)",
				"value": "ND"
			},
			{
				"label": "‘NH’(Not Held)",
				"value": "NH"
			},
			{
				"label": "‘OPO’ (Opt Out of Locked Market)",
				"value": "OPO"
			},
			{
				"label": "‘OPT’(Options Related Transaction)",
				"value": "OPT"
			},
			{
				"label": "‘OVD’(Over the Day)",
				"value": "OVD"
			},
			{
				"label": "‘PEG’(PEG)",
				"value": "PEG"
			},
			{
				"label": "‘RSV’(Reserve Size Order)",
				"value": "RSV"
			},
			{
				"label": "‘S.W’(Stop Stock Transaction )",
				"value": "S.W"
			},
			{
				"label": "‘SCL’(Scale)",
				"value": "SCL"
			},
			{
				"label": "‘SLD’ (Slide)",
				"value": "SLD"
			},
			{
				"label": "‘SLR’(Delivery Instructions: Seller’s Option - trade settles on a date determined by a seller.)",
				"value": "SLR"
			},
			{
				"label": "‘SLQ’ (Stop Limit on Quote)",
				"value": "SLQ"
			},
			{
				"label": "‘SOQ’ (Stop on Quote)",
				"value": "SOQ"
			},
			{
				"label": "‘STP’ (Self Trade Prevention)",
				"value": "STP"
			},
			{
				"label": "‘TAI’ (Trade-at ISO)",
				"value": "TAI"
			},
			{
				"label": "‘TMO’(Time Order)",
				"value": "TMO"
			},
			{
				"label": "‘TS’(Trailing Stop )",
				"value": "TS"
			},
			{
				"label": "‘WRK’(Work)",
				"value": "WRK"
			}
		]
	},
	{
		"header": "Splhand2",
		"field": "splHand2",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Splhand3",
		"field": "splHand3",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Splhand4",
		"field": "splHand4",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Splhand5",
		"field": "splHand5",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Trading Session Code ",
		"field": "tradingSessionCode",
		"datatype": "choice ",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "‘FOR’ (Foreign Market)",
				"value": "FOR"
			},
			{
				"label": "’PRE’ (Pre-Market Only)",
				"value": "PRE"
			},
			{
				"label": "‘PREREG’ (Pre-Market and Regular)",
				"value": "PREREG"
			},
			{
				"label": "‘REG’ (Regular Only)",
				"value": "REG"
			},
			{
				"label": "‘REGPOST’ (Regular and Post-Market)",
				"value": "REGPOST"
			},
			{
				"label": "‘POST’ (Post-Market Only)",
				"value": "POST"
			},
			{
				"label": "‘PREPOST’ (Pre-Market and Post-Market)",
				"value": "PREPOST"
			},
			{
				"label": "‘ALL’ (All Sessions)",
				"value": "ALL"
			}
		]
	},
	{
		"header": "Rec. Dept. ID",
		"field": "receivedDeptID",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Agency)",
				"value": "A"
			},
			{
				"label": "ATS-(Alternative Trading System)",
				"value": "ATS"
			},
			{
				"label": "MA-(Market Access)",
				"value": "MA"
			},
			{
				"label": "T-(Trading)",
				"value": "T"
			},
			{
				"label": "O-(Other)",
				"value": "O"
			}
		]
	},
	{
		"header": "Originating Dept ID",
		"field": "originatingDeptID",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Agency)",
				"value": "A"
			},
			{
				"label": "ATS-(Alternative Trading System)",
				"value": "ATS"
			},
			{
				"label": "MA-(Market Access)",
				"value": "MA"
			},
			{
				"label": "T-(Trading)",
				"value": "T"
			},
			{
				"label": "O-(Other)",
				"value": "O"
			}
		]
	},
	{
		"header": "Act Type",
		"field": "actType",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Institutional Customer)",
				"value": "A"
			},
			{
				"label": "C-(Combined)",
				"value": "C"
			},
			{
				"label": "E-(Employee Account)",
				"value": "E"
			},
			{
				"label": "I-(Individual Customer)",
				"value": "I"
			},
			{
				"label": "O-(Market Maker Proprietary)",
				"value": "O"
			},
			{
				"label": "P-(Other Proprietary)",
				"value": "P"
			},
			{
				"label": "U-(Unknown)",
				"value": "U"
			},
			{
				"label": "X-(Error Account)",
				"value": "X"
			}
		]
	},
	{
		"header": "Prog Trad",
		"field": "progTrad",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "N-(no)",
				"value": "N"
			},
			{
				"label": "X-(not known)",
				"value": "X"
			},
			{
				"label": "Y-(yes)",
				"value": "Y"
			}
		]
	},
	{
		"header": "Arbitrage",
		"field": "arbitrage",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "N-(no)",
				"value": "N"
			},
			{
				"label": "X-(not known)",
				"value": "X"
			},
			{
				"label": "Y-(yes)",
				"value": "Y"
			}
		]
	},
	{
		"header": "Execution Timestamp",
		"field": "executionTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Execution Quantity",
		"field": "executionQuantity",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Router Terminal ID",
		"field": "routerTerminalID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Reported Exception Code",
		"field": "reportedExceptionCode",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Market Center ID",
		"field": "marketCenterID",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "‘A’(NYSE American)",
				"value": "A"
			},
			{
				"label": "‘B’(Nasdaq BX)",
				"value": "B"
			},
			{
				"label": "‘C’(NYSE National Stock Exchange)",
				"value": "C"
			},
			{
				"label": "‘DN’(FINRA/NYSE TRF)",
				"value": "DN"
			},
			{
				"label": "‘D’(ADF)",
				"value": "D"
			},
			{
				"label": "‘F’(Non-US Exchange)",
				"value": "F"
			},
			{
				"label": "‘I’(International Securities Exchange)",
				"value": "I"
			},
			{
				"label": "‘J’ (CBOE EDGA Exchange)",
				"value": "J"
			},
			{
				"label": "‘K’ (CBOE EDGX Exchange)",
				"value": "K"
			},
			{
				"label": "‘L’(FINRA/NASDAQ TRF)",
				"value": "L"
			},
			{
				"label": "‘M’(Chicago Stock Exchange)",
				"value": "M"
			},
			{
				"label": "‘N’(New York Stock Exchange)",
				"value": "N"
			},
			{
				"label": "‘O’(OTC Reporting Facility)",
				"value": "O"
			},
			{
				"label": "‘P’(NYSE Arca Exchange)",
				"value": "P"
			},
			{
				"label": "‘Q’(The Nasdaq Stock Market)",
				"value": "Q"
			},
			{
				"label": "‘V’(Investors Exchange)",
				"value": "V"
			},
			{
				"label": "‘W’(CBOE Stock Exchange)",
				"value": "W"
			},
			{
				"label": "‘X’(Nasdaq PHLX)",
				"value": "X"
			},
			{
				"label": "‘Y’ (CBOE BYX Exchange )",
				"value": "Y"
			},
			{
				"label": "‘Z’ (CBOE BZX Exchange)",
				"value": "Z"
			}
		]
	},
	{
		"header": "Member Type Code",
		"field": "memberTypeCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Affiliate, Not a FINRA Member )",
				"value": "A"
			},
			{
				"label": "C-(ECN)",
				"value": "C"
			},
			{
				"label": "E-(Non-Reporting Member)",
				"value": "E"
			},
			{
				"label": "M-(FINRA Member)",
				"value": "M"
			},
			{
				"label": "N-(Not a FINRA Member)",
				"value": "N"
			},
			{
				"label": "F-(Foreign Affiliate)",
				"value": "F"
			},
			{
				"label": "X-(Foreign BD, not an Affiliate)",
				"value": "x"
			}
		]
	},
	{
		"header": "Ats Display Indicator",
		"field": "atsDisplayIndicator",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Execution Price",
		"field": "executionPrice",
		"datatype": "Float",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Capacity Code",
		"field": "capacityCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Agent)",
				"value": "A"
			},
			{
				"label": "P-(Principal)",
				"value": "P"
			},
			{
				"label": "R-(Riskless Principal)",
				"value": "R"
			}
		]
	},
	{
		"header": "Barrier ID",
		"field": "barrierID",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Rec Timestamp",
		"field": "deskRecTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Share Qty",
		"field": "deskShareQty",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Type Code",
		"field": "deskTypeCode",
		"datatype": "char",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Agency)",
				"value": "A"
			},
			{
				"label": "AR-(Arbitrage)",
				"value": "AR"
			},
			{
				"label": "B-(Block Trading)",
				"value": "B"
			},
			{
				"label": "C-(Convertible Desk)",
				"value": "C"
			},
			{
				"label": "CR-(Central Risk Books)",
				"value": "CR"
			},
			{
				"label": "D-(Derivatives)",
				"value": "D"
			},
			{
				"label": "EC-(Equity Capital Markets)",
				"value": "EC"
			},
			{
				"label": "IN-(International)",
				"value": "IN"
			},
			{
				"label": "IS-(Institutional)",
				"value": "IS"
			},
			{
				"label": "O-(Other)",
				"value": "O"
			},
			{
				"label": "PF-(Preferred Trading)",
				"value": "PF"
			},
			{
				"label": "PR-(Proprietary)",
				"value": "PR"
			},
			{
				"label": "PT-(Program Trading)",
				"value": "PT"
			},
			{
				"label": "S-(Sales)",
				"value": "S"
			},
			{
				"label": "SW-(Swaps)",
				"value": "SW"
			},
			{
				"label": "T-(Trading)",
				"value": "T"
			},
			{
				"label": "TR-(Treasury)",
				"value": "TR"
			}
		]
	},
	{
		"header": "Desk Spl Hand1",
		"field": "deskSplHand1",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Spl Hand2",
		"field": "deskSplHand2",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Spl Hand3",
		"field": "deskSplHand3",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Spl Hand4",
		"field": "deskSplHand4",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Desk Spl Hand5",
		"field": "deskSplHand5",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Tmo Trigger Timestamp",
		"field": "tmoTriggerTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Negotiated Trade Flag",
		"field": "negotiatedTradeFlag",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Order Origination Code",
		"field": "orderOriginationCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "F-(Order Originated with Firm)",
				"value": "F"
			},
			{
				"label": "W-(Received from another Broker/Dealer)",
				"value": "W"
			}
		]
	},
	{
		"header": "Execution Type Indicator",
		"field": "executionTypeIndicator",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "F-(full execution)",
				"value": "F"
			},
			{
				"label": "P-(partial execution)",
				"value": "P"
			}
		]
	},
	{
		"header": "Leaves Quantity",
		"field": "leavesQuantity",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Originating MPID",
		"field": "originatingMpid",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Order Cancel Timestamp",
		"field": "orderCancelTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Cancelled By / Modified By",
		"field": "cancelledByORModifiedBy",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "C-(Customer Cancelled,Customer Modified)",
				"value": "C"
			},
			{
				"label": "F-(Firm Cancelled,Firm Modified)",
				"value": "F"
			}
		]
	},
	{
		"header": "Cancel Type",
		"field": "cancelType",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "F-(full)",
				"value": "F"
			},
			{
				"label": "P-(partial)",
				"value": "P"
			}
		]
	}
]